import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Funcție care extrage calea dintr-un URL complet
const getPathFromUrl = (url) => {
  try {
    if (url.startsWith('/')) {
      return url; // Este deja un path relativ, îl returnăm direct
    }
    const { pathname } = new URL(url);
    return pathname;
  } catch (error) {
    console.error('Eroare la extragerea URL-ului:', error);
    return url;
  }
};

const ProtectedRoute = ({ children, requiredUrl }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Citim permisiunile din localStorage
    const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
    if (!storedPermissions || !storedPermissions.pages) {
      navigate('/not_authorized');
      return;
    }

    const permissions = storedPermissions.pages;

    const extractedRequiredUrl = getPathFromUrl(requiredUrl);

    const hasPermission = permissions.some(
      (page) => getPathFromUrl(page.url) === extractedRequiredUrl && page.can_view === true
    );

    if (!hasPermission) {
      navigate('/not_authorized');
    }
  }, [requiredUrl, navigate]); // Asigură-te că efectul este rerulat la fiecare schimbare de URL

  const extractedRequiredUrl = getPathFromUrl(requiredUrl);
  const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
  const permissions = storedPermissions?.pages || [];

  const hasPermission = permissions.some(
    (page) => getPathFromUrl(page.url) === extractedRequiredUrl && page.can_view === true
  );


  if (!hasPermission) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
